module.exports = require("@material-ui/lab/SpeedDialIcon");